import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/layout/Header';

const StrategyMeeting: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="navbar-bg-fixed"><Header /></div>
      <div className="news-page py-5 mt-5">
        <Container>
          {/* Header Image */}
          <img src="/images/News/Sub-news/5.1.jpg" alt="Strategy Meeting Header" className="w-100 rounded mb-4 mt-3 header-img image-hover-animation" style={{ maxHeight: 260, objectFit: 'cover' }} />
          {/* Title and Date */}
          <h2 className="fw-bold mb-1 header-2 color-brown">| {t('news.articles.strategyMeeting.title')}</h2>
          <div className="mb-3"><span className='menu-item'>{t('news.date')}:</span> <span className='body-text'>{t('news.articles.strategyMeeting.date')}</span> </div>
          {/* Main Text */}
          <div className="mb-4 body-text" style={{ color: '#333' }}>
            {t('news.articles.strategyMeeting.description')}
          </div>
          {/* Two-column image grid */}
          <Row className="mb-5 g-2">
            <Col md={6}>
              <img src="/images/News/Sub-news/10.jpg" alt="Strategy Meeting 1" className="w-100 image-hover-animation" style={{ objectFit: 'cover', height: 455 }} />
            </Col>
            <Col md={6}>
              <img src="/images/News/Sub-news/10.1.jpg" alt="Strategy Meeting 2" className="w-100 image-hover-animation" style={{ objectFit: 'cover', height: 455 }} />
            </Col>
          </Row>
          {/* Related News */}
          <div className="fw-bold mb-3 border-bottom border-bottom-brown" style={{ fontSize: 16 }}>{t('news.related')}:</div>
          <Row className="top-news">
            {/* Left: Large Related News */}
            <Col lg={6}>
              <div className="news-card large position-relative">
                <div className="news-category">{t('news.category')}</div>
                <img 
                  src="/images/News/Sub-news/13.1.jpg" 
                  alt="CLA Conference" 
                  className="news-image w-100 image-hover-animation"
                />
                <div className="news-content">
                  <h3>{t('news.related3.title')}</h3>
                </div>
                <Button as={Link as any} to="/news/meeting-with-officer" className="news-read-more">{t('news.readMore')}</Button>
              </div>
            </Col>
            {/* Right: Three Small Related News */}
            <Col lg={6}>
              <Row className="g-2">
                <Col xs={12}>
                  <div className="news-card medium position-relative">
                    <div className="news-category">{t('news.category')}</div>
                    <img 
                      src="/images/News/Sub-news/7.jpg" 
                      alt="Strategy Meeting" 
                      className="news-image w-100 image-hover-animation"
                    />
                    <div className="news-content">
                      <h3>{t('news.related4.title')}</h3>
                    </div>
                    <Button as={Link as any} to="/news/annual-party" className="news-read-more">{t('news.readMore')}</Button>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="news-card small position-relative">
                    <div className="news-category">{t('news.category')}</div>
                    <img 
                      src="/images/News/Sub-news/1.png" 
                      alt="Meeting with Officer" 
                      className="news-image w-100 image-hover-animation"
                    />
                    <div className="news-content">
                      <h3>{t('news.related5.title')}</h3>
                    </div>
                    <Button as={Link as any} to="/news/charity" className="news-read-more">{t('news.readMore')}</Button>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="news-card small position-relative">
                    <div className="news-category">{t('news.category')}</div>
                    <img 
                      src="/images/News/Sub-news/6.jpg" 
                      alt="R . L's Annual Party" 
                      className="news-image w-100 image-hover-animation"
                    />
                    <div className="news-content">
                      <h3>{t('news.related1.title')}</h3>
                    </div>
                    <Button as={Link as any} to="/news/receiving-certificate-from-cla" className="news-read-more">{t('news.readMore')}</Button>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default StrategyMeeting; 